import { render, staticRenderFns } from "./solution-item.vue?vue&type=template&id=6f853a7d"
import script from "./solution-item.vue?vue&type=script&lang=js"
export * from "./solution-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports